(() => {
  'use strict';

  function syncSpecAccordion(item, index) {
    const button = item.querySelector('.spec-header');
    const content = item.querySelector('.spec-content');
    if (!button || !content) return;

    if (!content.id) content.id = `product-spec-content-${index + 1}`;
    button.setAttribute('aria-controls', content.id);
    button.setAttribute('aria-expanded', String(item.classList.contains('active')));
  }

  function initSpecAccordions() {
    const roots = Array.from(document.querySelectorAll('.watch-specs-inline'));
    if (!roots.length) return;

    const items = Array.from(document.querySelectorAll('.spec-item-accordion'));
    items.forEach(syncSpecAccordion);

    roots.forEach((root) => {
      root.addEventListener('click', (event) => {
        const button = event.target.closest?.('.spec-header');
        if (!button || !root.contains(button)) return;

        const item = button.closest('.spec-item-accordion');
        if (!item) return;

        const wasActive = item.classList.contains('active');
        document.querySelectorAll('.spec-item-accordion').forEach((el) => {
          if (el !== item) el.classList.remove('active');
        });
        item.classList.toggle('active', !wasActive);

        requestAnimationFrame(() => {
          Array.from(document.querySelectorAll('.spec-item-accordion')).forEach(syncSpecAccordion);
        });
      });
    });
  }

  function patchLaiReviewLocale(helpfulLabel) {
    if (!helpfulLabel || typeof scmLanguage !== 'string' || !scmLanguage.includes('Translation missing')) {
      return false;
    }
    scmLanguage = scmLanguage.replace(
      /"helpful":\s*"Translation missing:[^"]*"/,
      '"helpful": ' + JSON.stringify(helpfulLabel)
    );
    return !scmLanguage.includes('Translation missing');
  }

  function initLaiReviewLocale() {
    const script = document.querySelector('script[data-lai-helpful][src*="product-quality"]');
    const helpfulLabel = script?.getAttribute('data-lai-helpful');
    if (!helpfulLabel) return;

    if (patchLaiReviewLocale(helpfulLabel)) return;

    let tries = 0;
    const timer = setInterval(() => {
      if (patchLaiReviewLocale(helpfulLabel) || ++tries > 50) clearInterval(timer);
    }, 50);
    document.addEventListener('DOMContentLoaded', () => patchLaiReviewLocale(helpfulLabel), { once: true });
  }

  function init() {
    initSpecAccordions();
    initLaiReviewLocale();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
